import {FormBuilderFieldTypeOptionsV2} from 'src/types/FormV2';
import type {FormBuilderRegistry} from './registry';
import {AssetModalSettings} from './components/FieldSettings/components/AssetModalSettings';
import {ComplianceSettings} from './components/FieldSettings/components/ComplianceSettings';
import {DropdownSettings} from './components/FieldSettings/components/DropdownSettings';
import {FailureSettings} from './components/FieldSettings/components/FailureSettings';
import {FileUploadSettings} from './components/FieldSettings/components/FileUploadSettings';
import {GeneralSettings} from './components/FieldSettings/components/GeneralSettings/GeneralSettings';
import {PersonSettings} from './components/FieldSettings/components/PersonSettings';
import {ReferenceImageSettings} from './components/FieldSettings/components/ReferenceImageSettings';
import {ScaleSettings} from './components/FieldSettings/components/ScaleSettings';
import {SubFormSettings} from './components/FieldSettings/components/SubFormSettings';
import {VisibilityRuleSettings} from './components/FieldSettings/components/VisibilityRuleSettings/VisibilityRuleSettings';
import {YesNoSettings} from './components/FieldSettings/components/YesNoSettings';

/**
 * Default `FormBuilderRegistry` for the Forms module: the full field-type
 * palette, every top-level settings panel (today's exact order from
 * `FieldSettings.tsx`, preserved — `ComplianceSettings`/`FailureSettings`
 * are top-level panels alongside `YesNoSettings`, all self-filtering on
 * `field.type === 'switch'`), and the Form Settings accordion enabled.
 */
export const formBuilderRegistry: FormBuilderRegistry = {
  fieldTypes: FormBuilderFieldTypeOptionsV2,
  settingsPanels: [
    GeneralSettings,
    SubFormSettings,
    DropdownSettings,
    AssetModalSettings,
    PersonSettings,
    YesNoSettings,
    ComplianceSettings,
    FailureSettings,
    ScaleSettings,
    FileUploadSettings,
    ReferenceImageSettings,
    VisibilityRuleSettings,
  ],
  showFormSettings: true,
};
